import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Header from '../header';
import Questions from './views/questions';
import * as DataStatic from '../../api/homeDataStatic';
import Footer from '../footer';
import RaisedButton from 'material-ui/RaisedButton';
import './style.scss';
// https://css-tricks.com/aos-css-driven-scroll-animation-library/
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css'; 

import videoMP4 from "../common/Writing-Working/Writing-Working.mp4";
import videoWebm from "../common/Writing-Working/Writing-Working.webm";
import poster from "../common/Writing-Working/Writing-Working.jpg"

export default class PageController extends Component {
    constructor(props){
        super(props);
        console.log("props ", props)
        this.handleClick = this.handleClick.bind();
        AOS.init();
    }

    componentWillReceiveProps (){ 
        AOS.refresh(); 
    } 

    componentDidMount(){
        let pageName = this.props.match.params.name;
    }

    handleClick = () => {
        console.log( this )
        this.props.history.push("/build-your-team");
    }

    render(){
        const { title, name, content, image } = this.props.data;
        const styles = {
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }
        const styleGrid = {
            width: "61.25rem",
            margin: " 100px auto"
        }
        return(
            <div key={`page-${name}`}>
                <MetaTags>
                    <title>{`App2soft | ${this.props.data.name}`}</title>
                    <meta name="description" content={`${this.props.data.title}`} />
                    <meta name="keywords" content={`${this.props.data.keywords}`}/>
                    <meta name="author" content="Upway Solutions" />
                    <meta property="og:image" content={`${logo}`} />
                </MetaTags>
                <Header animation={false}/>
                <section className="page">
                    <div className="page-title">
                        <div className="title" data-aos="fade-down"> 
                            <h2 data-aos="fade-up">{title}</h2>
                        </div>
                        <video poster={poster} autoPlay loop>
                            <source src={videoMP4} type="video/mp4" />Your browser does not support the video tag. I suggest you upgrade your browser.
                            <source src={videoWebm} type="video/webm" />
                        </video>
                    </div>
                    <div className="main">
                        { content.map( (block, index) => {

                            let block1 = "block1";
                            let block2 = "block2";
                            let onlyColor = "onlyColor";

                            if ( index % 2 == 0  ){
                                block1 = "block2";
                                block2 = "block1"
                                onlyColor = ""
                            }

                            return (
                                <div className="item" data-aos="fade-up">
                                    <div className={`grid ${onlyColor}`}>
                                        <img src={block.image} width="100%" className={block1} data-aos="zoom-in" />
                                        <div className={`content ${block2}`}>
                                            <h3>{block.title}</h3>
                                            <p>{block.text}</p><br/>
                                            <RaisedButton label="Build your Team" primary={true} onClick={ this.handleClick }/>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}    
                    </div>
                </section>
                <div className="questions" data-aos="fade-up">
                    <h2>Build your online team</h2>
                    <RaisedButton label="Get Started" primary={true} onClick={ this.handleClick }/>
                </div>
                <Footer />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/page/index.js